import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=e4486a0c&"
import script from "./MenuCard.vue?vue&type=script&lang=js&"
export * from "./MenuCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4486a0c')) {
      api.createRecord('e4486a0c', component.options)
    } else {
      api.reload('e4486a0c', component.options)
    }
    module.hot.accept("./MenuCard.vue?vue&type=template&id=e4486a0c&", function () {
      api.rerender('e4486a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MenuCard.vue"
export default component.exports